export default "__VITE_ASSET__iG89yjMQ__"